// extracted by mini-css-extract-plugin
module.exports = {"root":"BYOMobileDescription_root__1ByHq","spinAround":"BYOMobileDescription_spinAround__2YnXw"};